import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { Results} from './types';
import { Module } from 'vuex';
import { RootState } from '../types';

export const results: Module<Results, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
